const trim = (value: string | undefined) => value?.trim().replace(/\/$/, "") ?? "";
const enabled = (value: string | undefined) => ["1", "true", "yes", "on"].includes(value?.trim().toLowerCase() ?? "");
const enabledByDefault = (value: string | undefined, fallback: boolean) => value == null || !value.trim() ? fallback : enabled(value);

// These are public runtime identifiers shared by every product surface. Secret
// and service-role keys must never be added here. Environment variables still
// override every value for staging and production deployments.
const appPublicRuntime = {
  supabaseUrl: "https://teovkzgasvnazebtwqix.supabase.co",
  supabasePublishableKey: "sb_publishable_LYpNOMdLBSTT0V6SwxxVcA_LZV6I8g6",
  gatewayUrl: import.meta.env.DEV ? "/gateway" : "https://api.mvpstoryai.com",
};

export interface RuntimeConfig {
  localUiOnly: boolean;
  supabaseUrl: string;
  supabasePublishableKey: string;
  gatewayUrl: string;
  defaultModel: string;
  structuredRuntimeEnabled: boolean;
  compactTurnsEnabled: boolean;
  demoDataEnabled: boolean;
}

const localUiOnly = import.meta.env.DEV && import.meta.env.MODE === "local-ui";

export const runtimeConfig: RuntimeConfig = {
  localUiOnly,
  supabaseUrl: localUiOnly ? "" : trim(import.meta.env.VITE_SUPABASE_URL) || appPublicRuntime.supabaseUrl,
  supabasePublishableKey: localUiOnly ? "" : trim(import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY) || appPublicRuntime.supabasePublishableKey,
  gatewayUrl: localUiOnly ? "" : trim(import.meta.env.VITE_GATEWAY_URL) || appPublicRuntime.gatewayUrl,
  defaultModel: trim(import.meta.env.VITE_DEFAULT_MODEL) || "deepinfra-glm-5.3-flash",
  structuredRuntimeEnabled: enabledByDefault(import.meta.env.VITE_STRUCTURED_RUNTIME_ENABLED, true),
  compactTurnsEnabled: enabled(import.meta.env.VITE_COMPACT_TURNS_ENABLED),
  demoDataEnabled: localUiOnly || enabled(import.meta.env.VITE_ENABLE_DEMO_DATA),
};

export const hasCloudRuntime = Boolean(runtimeConfig.supabaseUrl && runtimeConfig.supabasePublishableKey);
export const hasNarrationGateway = Boolean(runtimeConfig.gatewayUrl);
